function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '../../shared/components/spzaComponent';
import { Constants } from '../../shared/utils/constants';
import { InternalLink } from '../../shared/components/internalLink';
import * as DetailUtils from '../../shared/utils/detailUtils';
import { urlPush } from '../../shared/routerHistory';
export var UsefulInfoMetadataCellItemType = /*#__PURE__*/ function(UsefulInfoMetadataCellItemType) {
    UsefulInfoMetadataCellItemType[UsefulInfoMetadataCellItemType["Filter"] = 0] = "Filter";
    UsefulInfoMetadataCellItemType[UsefulInfoMetadataCellItemType["Label"] = 1] = "Label";
    UsefulInfoMetadataCellItemType[UsefulInfoMetadataCellItemType["Link"] = 2] = "Link";
    UsefulInfoMetadataCellItemType[UsefulInfoMetadataCellItemType["Modal"] = 3] = "Modal";
    UsefulInfoMetadataCellItemType[UsefulInfoMetadataCellItemType["InternalLink"] = 4] = "InternalLink";
    return UsefulInfoMetadataCellItemType;
}({});
const isUsefulInfoMetadataCellItemFilter = (object)=>{
    return object.type === 0;
};
const isUsefulInfoMetadataCellItemInternalLink = (object)=>{
    return object.type === 4;
};
const isUsefulInfoMetadataCellItemLink = (object)=>{
    return object.type === 2;
};
const isUsefulInfoMetadataCellItemModal = (object)=>{
    return object.type === 3;
};
export class UsefulInfo extends SpzaComponent {
    getLinkElement(item) {
        if (item.information) {
            return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
                className: "c-hyperlink",
                rel: "noreferrer",
                target: "_blank",
                href: item.information,
                title: this.context.loc(item.text),
                onClick: ()=>{
                    DetailUtils.generateLinkPayloadAndLogTelemetry(this.props.ownerType, item.entityId, item.id, item.information, 'Default');
                }
            }, item.props), {
                children: this.context.loc(item.text)
            }));
        } else {
            return null;
        }
    }
    getInternalLinkElement(item) {
        return /*#__PURE__*/ _jsx(InternalLink, _object_spread_props(_object_spread({
            className: "c-hyperlink",
            href: item.information,
            onClick: item.onClick
        }, item.props), {
            children: this.context.loc(item.text)
        }));
    }
    getFilterElement(item) {
        const filter = item.filter;
        if (item.nationalCloud) {
            return /*#__PURE__*/ _jsx("div", {
                children: this.context.loc(filter.locKey, filter.title)
            }, filter.title);
        } else {
            return /*#__PURE__*/ _jsxs(InternalLink, _object_spread_props(_object_spread({
                className: "c-hyperlink detailsCategories",
                href: filter.newPath,
                title: this.context.loc(filter.locKey, filter.title),
                onClick: (e)=>{
                    DetailUtils.generateLinkPayloadAndLogTelemetry(DetailUtils.OwnerType.App, item.entityId, filter.filterItem, filter.newPath, 'Default');
                    // The embedded app needs to open these links in a new window
                    if (item.isEmbedded) {
                        // eslint-disable-next-line security/detect-non-literal-fs-filename
                        window.open(window.location.origin + filter.newPath, '_blank');
                    } else {
                        urlPush(filter.newPath);
                        window.scrollTo(0, 0);
                    }
                    // The preventDefault prevents the route from transitioning and thus refreshing the page.
                    e.preventDefault();
                },
                accEnabled: true
            }, item.props), {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: this.context.loc(filter.locKey, filter.title)
                    }),
                    filter.filterItem === Constants.filterMaps.categories ? /*#__PURE__*/ _jsx("meta", {
                        itemProp: "applicationCategory",
                        content: this.context.loc(filter.locKey, filter.title)
                    }) : null
                ]
            }), filter.title);
        }
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            className: "usefulInfo ",
            children: this.props.metadata.map((col)=>{
                return /*#__PURE__*/ _jsxs("div", {
                    className: "usefulInfoColumn",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "columnTitle",
                            children: this.context.loc(col.title, col.titleFallback || col.title)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "columnCells",
                            children: col.cells.map((cell)=>{
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "cell",
                                    itemProp: cell.id,
                                    children: [
                                        cell.title && /*#__PURE__*/ _jsx("header", {
                                            "aria-label": cell.title,
                                            children: this.context.loc(cell.title, cell.titleFallback || cell.title)
                                        }),
                                        cell.cellItems.map((item)=>{
                                            if (isUsefulInfoMetadataCellItemFilter(item)) {
                                                return this.getFilterElement(item);
                                            } else if (isUsefulInfoMetadataCellItemLink(item)) {
                                                return this.getLinkElement(item);
                                            } else if (isUsefulInfoMetadataCellItemModal(item)) {
                                                return item.getContent();
                                            } else if (isUsefulInfoMetadataCellItemInternalLink(item)) {
                                                return this.getInternalLinkElement(item);
                                            } else {
                                                return /*#__PURE__*/ _jsx("span", _object_spread_props(_object_spread({
                                                    className: "cellLabel"
                                                }, item.props), {
                                                    children: this.context.loc(item.text)
                                                }), item.text);
                                            }
                                        })
                                    ]
                                }, cell.id);
                            }).filter(Boolean)
                        })
                    ]
                }, col.id);
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
UsefulInfo.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
